import Cookies from 'js-cookie'

const getToken = () => {
  let token = window.localStorage.getItem('token');

  if(!token) {
    token = Cookies.get('token');
  }

  return token;
};

export default getToken;
